module.exports = __webpack_public_path__ + "img/ctcc.95518670.jpg";